import { mapGetters, mapMutations } from "vuex";
import { calcUserName } from '_lib/CalcUserInfo'
import Cache from '_lib/DataCache'
import { findChannel } from '_js/find-channel'
import { CHANNEL_USER_ACTIVE_VOLUME } from '@/common/constants/channel'

export default {
  data() {
    return {
      lastSendVolumeActiveState: {}
    }
  },
  mounted() {
    this.registerOverlayCb()
  },
  watch: {
    cur_channel_data: {
      handler(v) {
        if (!v.channel_id) {
          this.sendClientChannelData('channel', null)
        }
      },
      deep: true,
    },
    user_volumes: {
      handler(v) {
        if (this.cur_channel_data.channel_id && this.checkNeedSendClientChannelData()) {
          let need_update_volume_data = false
          // lastSendVolumeActiveState中的id和user_volumes中的id可能存在差异，需要对比所有的id才能确认是否需要更新overlay数据
          let ids = Object.keys(v)
          Object.keys(this.lastSendVolumeActiveState).forEach(id => {
            if (!ids.includes(id)) {
              ids.push(id)
            }
          })

          for (let id of ids) {
            let isActive = v[id] === undefined ? undefined : v[id] > CHANNEL_USER_ACTIVE_VOLUME
            if (isActive !== this.lastSendVolumeActiveState[id]) {
              this.lastSendVolumeActiveState[id] = isActive
              need_update_volume_data = true
            }
          }
          if (need_update_volume_data) {
            // console.log('send', JSON.parse(JSON.stringify(this.lastSendVolumeActiveState)), JSON.parse(JSON.stringify(v)))
            this.sendClientChannelData('volume', v)
          }
        }
      },
      deep: true,
    },
    sound_message_active: {
      handler(v) {
        if (this.cur_channel_data.channel_id) {
          this.sendClientChannelData('sound_msg', v)
        }
      },
      deep: true,
    },
    member_voice_level: {
      handler(v) {
        if (this.cur_channel_data.channel_id) {
          this.sendClientChannelData('member_voice', v)
        }
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters([
      "user_volumes", 
      'cur_channel_data',
      'setting_data', 
      'member_voice_level',
      'sound_message_active',
      'screen_sharing_info',
      'screen_share_state_user_list',
      'user_info',
    ]),
  },
  methods: {
    registerOverlayCb() {
      if (window.overlayAPI) {
        window.overlayAPI.onChangeOverlayShowState(async (show) => {
          if (show) {
            let { room_id, channel_id } = this.cur_channel_data
            if (!room_id || !channel_id) return
  
            let cache_data = await Cache.getRoomCache(room_id)
            let channels = cache_data?.channels
            let cur_channel = await findChannel(channel_id, channels)
            if (cur_channel && cur_channel.members && cur_channel.members.length > 0) {
              for (let member of cur_channel.members) {
                member._calc_nickname = calcUserName(member)
              }
            }
            if (cur_channel) {
              if (!cur_channel.members) cur_channel.members = []
              window.overlayAPI.sendChannelData({
                data: cur_channel,
                type: 'channel'
              })
            }
          }
        })
      }
    },
    sendClientChannelData(type, v) {
      if (this.checkNeedSendClientChannelData()) {
        window.overlayAPI.sendChannelData({
          data: v,
          type: type
        })
      }
    },
    checkNeedSendClientChannelData() {
      return (window.overlayAPI && window.overlayAPI.overlayShow) || (window.obsOverlayAPI && window.obsOverlayAPI.serverStart)
    }
    // 在home中监听频道数据ws，用于更新悬浮窗数据
    // handleSendChannelData(data) {
    //   let channels = data.data.channels
    //   if (window.overlayAPI && window.overlayAPI.sendChannelData) {
    //     let cur_channel = this.findChannel(this.cur_channel_data.channel_id, channels)
    //     if (cur_channel) window.overlayAPI.sendChannelData({
    //       data: cur_channel,
    //       type: 'channel'
    //     })
    //   }
    // },
  },
}
